import React, { useState } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { ActionHandlerFunction, OrgInfo } from "@preveil-api";
import { Account, AdminErrorMessages, AdminSuccessMessages, AdminUIActionTypes, EmailGatewayEntity, Message, MessageHandlerDisplayType, useAppDispatch, usePostUsersOrgsByEntityIdGatewayAliasesMutation } from "src/common";
import { GroupForm, IndividualForm } from "..";
import { uiActions } from "src/store";

type AllProps = {
  org_info: OrgInfo;
  current_account: Account;
  show_modal: boolean;
  address_list: string[];
  handleAction: ActionHandlerFunction;
};

function AddToEmailGatewayComponent(props: AllProps) {
  const { show_modal, handleAction, address_list, org_info, current_account } = props;
  const dispatch = useAppDispatch();
  const tab_event_key = {
    individual: "Add Secure Email Relay Addresses or Domains",
    csv_upload: "Import Secure Email Relay Addresses or Domains"
  };
  const [tab_heading, setTabHeading] = useState<string>(tab_event_key.individual);
  const [postUsersOrgsByEntityIdGatewayAliases] = usePostUsersOrgsByEntityIdGatewayAliasesMutation();

  // Description: Handling changing modal tabs and including the correct header.
  function handleTabSelect(event_key: string | null) {
    const tab_heading = event_key === "csv_upload" ? tab_event_key.csv_upload : tab_event_key.individual;
    setTabHeading(tab_heading);
  }

  async function submitAddresses(addresses: EmailGatewayEntity[]) {
    handleAction({ actionType: AdminUIActionTypes.ShowModal });
    const entity_id = org_info.org_id;
    const account_ids = Account.getAccountIdentifiers(current_account);
    await postUsersOrgsByEntityIdGatewayAliases({
      account_ids,
      body: {
        entityId: entity_id,
        aliases: addresses
      }
    })
      .unwrap()
      .then(() => {
        dispatch(
          uiActions.handleSetMessage(
            new Message(AdminSuccessMessages.success_add_email_gateway_address),
          ),
        );
      })
      .catch((error) => {
        const message = AdminErrorMessages.error_adding_email_gateway;
        dispatch(uiActions.handleRequestErrors(new Message(message, MessageHandlerDisplayType.toastr), error));
      });
  }

  return <Modal
    size="lg"
    show={show_modal}
    onHide={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
    centered
    aria-label={tab_heading}
  >
    <Modal.Header closeButton>
      <Modal.Title>{tab_heading}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Tabs defaultActiveKey="individual" id="add-email-relay-tabs" onSelect={handleTabSelect}>
        <Tab eventKey="individual" title="Individual">
          <IndividualForm
            handleAction={handleAction}
            saved_address_list={address_list}
            submitAddresses={submitAddresses}
          />
        </Tab>
        <Tab eventKey="csv_upload" title="CSV Upload">
          <GroupForm handleAction={handleAction} address_list={address_list} submitAddresses={submitAddresses} />
        </Tab>
      </Tabs>
    </Modal.Body>
  </Modal >;
}

export default React.memo(AddToEmailGatewayComponent);
